// @ts-ignore
import type {IVehicleState} from './states/IVehicleState.interface';

const vehicle = {
    prefix: 'vehicle.',
    namespaced: true,
    state: <IVehicleState>{
        selectedVehicle: null,
        selectedId: 0,
    },
    mutations: {
        SET_STATE_PROP_VALUE(state: IVehicleState, payload: {prop: string, value: any}[]): void {
            for (const obj of payload) {
                if (! state.hasOwnProperty(obj.prop)) {
                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                const value = obj.value;

                state[prop] = value;

                localStorage.removeItem(vehicle.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(vehicle.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },
        INITIALIZE(state: IVehicleState): void {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {
                let value = localStorage.getItem(vehicle.prefix + prop);

                if (value) {
                    state[prop] = JSON.parse(value);
                }
            }
        },
        CLEAR_STATE(state: IVehicleState): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(vehicle.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
        }
    },
    actions: {

    },
    getters: {

    }

}

export default vehicle;


